import React from "react";
import {
    ChevronLeft,
    ChevronRight,
} from "lucide-react";

const Pagination = ({
    currentPage,
    totalPages,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
}) => {
    const pageNumbers = [];

    // If there's only one page, just add it
    if (totalPages === 1) {
        pageNumbers.push(1);
    } else {
        // Always add page 1
        pageNumbers.push(1);

        // Calculate the range of pages to show around the current page
        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);

        // Add ellipsis if there's a gap between page 1 and startPage
        if (startPage > 2) {
            pageNumbers.push("...");
        }

        // Add the range of pages (startPage to endPage)
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        // Add ellipsis if there's a gap between endPage and the last page
        if (endPage < totalPages - 1) {
            pageNumbers.push("...");
        }

        // Add the last page if totalPages > 1
        if (totalPages > 1) {
            pageNumbers.push(totalPages);
        }
    }

    return (
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mt-6 py-2 overflow-hidden">
            <div className="flex items-center gap-3">
                <span className="text-sm font-normal text-gray-600">Rows per page:</span>
                <select
                    value={rowsPerPage}
                    onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
                    className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-blue-500 transition-all duration-200 ease-in-out"
                >
                    {[5, 10, 20, 50, 100].map((rows) => (
                        <option key={rows} value={rows}>
                            {rows}
                        </option>
                    ))}
                </select>
            </div>

            <div className="flex items-center space-x-2">
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="p-2 border border-gray-300 rounded-lg text-gray-600 hover:bg-blue-100 hover:text-blue-700 hover:scale-105 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 ease-in-out"
                >
                    <ChevronLeft size={18} />
                </button>

                {pageNumbers.map((page, idx) =>
                    typeof page === "string" ? (
                        <span
                            key={`ellipsis-${idx}`}
                            className="px-3 text-gray-400 hover:text-gray-600 "
                        >
                            {page}
                        </span>
                    ) : (
                        <button
                            key={page}
                            className={`px-4 py-1.5 border border-gray-300 rounded-lg text-gray-600 ${currentPage === page
                                ? "bg-blue-600 text-white hover:bg-blue-700"
                                : "hover:bg-blue-100 hover:text-blue-700 hover:scale-105"
                                } `}
                            onClick={() => onPageChange(page)}
                        >
                            {page}
                        </button>
                    )
                )}

                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="p-2 border border-gray-300 rounded-lg text-gray-600 hover:bg-blue-100 hover:text-blue-700 hover:scale-105 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 ease-in-out"
                >
                    <ChevronRight size={18} />
                </button>
            </div>
        </div>
    );
};

export default Pagination;